module.exports = __webpack_public_path__ + "img/circle_recover.b24e3b8c.png";